// TODO: make it a function with context as argument, and return http://localhost in case of SSR
export const API_URL = "/api"
